var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoThrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1.5C8.06 1.5 7.5 2.06 7.5 2.75V4H12V2.75C12 2.06 11.44 1.5 10.75 1.5H8.75ZM13.5 4V2.75C13.5 1.231 12.269 0 10.75 0H8.75C7.231 0 6 1.231 6 2.75V4H0.75C0.336 4 0 4.336 0 4.75C0 5.164 0.336 5.5 0.75 5.5H1.079L2.807 21.054C2.961 22.446 4.139 23.5 5.54 23.5H13.96C15.361 23.5 16.538 22.446 16.693 21.054L18.421 5.5H18.75C19.164 5.5 19.5 5.164 19.5 4.75C19.5 4.336 19.164 4 18.75 4H13.5ZM16.912 5.5H2.588L4.298 20.888C4.368 21.521 4.903 22 5.54 22H13.96C14.597 22 15.132 21.521 15.202 20.888L16.912 5.5ZM7.75 9C8.164 9 8.5 9.336 8.5 9.75V17.75C8.5 18.164 8.164 18.5 7.75 18.5C7.336 18.5 7 18.164 7 17.75V9.75C7 9.336 7.336 9 7.75 9ZM11.75 9C12.164 9 12.5 9.336 12.5 9.75V17.75C12.5 18.164 12.164 18.5 11.75 18.5C11.336 18.5 11 18.164 11 17.75V9.75C11 9.336 11.336 9 11.75 9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThrash);
export default __webpack_public_path__ + "static/media/ico-thrash.f1ecf202.svg";
export { ForwardRef as ReactComponent };